import { captureException } from '@sentry/react'
import type { FirebaseRepository } from '@breakoutlearning/firebase-repository/models/FirebaseRepository'

export function captureVitePreloadError(
  event: VitePreloadErrorEvent,
  repository: Pick<FirebaseRepository, 'isAuthenticated'>
) {
  // Logged-out page loads are almost all email link scanners (Chrome from
  // Microsoft IPs, opening a dozen assignment links each) that tear the page
  // down mid-fetch. In the week to 2026-10-10, ~1,020 of 1,047 events in
  // CASES-REACT-17X had no user, and they buried the real-user failures.
  if (!repository.isAuthenticated) return

  captureException(event.payload, {
    contexts: {
      vite_preload_error: {
        event_type: event.type,
        event_time_stamp: event.timeStamp,
        event_bubbles: event.bubbles,
        event_cancelable: event.cancelable,
        event_composed: event.composed,
        event_default_prevented: event.defaultPrevented,
        event_is_trusted: event.isTrusted,
        error_name: event.payload.name,
        ...getOwnProperties(event.payload),
      },
      page: {
        url: `${window.location.origin}${window.location.pathname}`,
        visibility_state: document.visibilityState,
      },
    },
  })
}

export function logVitePreloadError(
  event: VitePreloadErrorEvent,
  repository: Pick<FirebaseRepository, 'logEvent'>
) {
  repository.logEvent('vite_preload_error', {
    error_name: event.payload.name,
    error_message: event.payload.message,
    page_path: window.location.pathname,
    visibility_state: document.visibilityState,
  })
}

function getOwnProperties(value: object) {
  const properties: Record<string, unknown> = {}

  for (const propertyName of Object.getOwnPropertyNames(value)) {
    properties[propertyName] = Object.getOwnPropertyDescriptor(
      value,
      propertyName
    )?.value
  }

  return properties
}
